import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  extendedWarrantyFromModel,
  validateExtendedWarrantyCondition,
  type ExtendedWarrantyState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const EXTENDED_WARRANTY = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ExtendedWarrantyState>
  >,
): ConditionType<ExtendedWarrantyState, Condition.ExtendedWarranty> => ({
  name: "Extended warranty is live on item",
  description() {
    return "Extended warranty is live on item";
  },
  Details(props: ConditionTypeDetailsProps<ExtendedWarrantyState>) {
    return React.createElement(Details, props);
  },
  empty: {},
  fromModel(model) {
    return extendedWarrantyFromModel(model);
  },
  toModel(state) {
    return { type: Condition.EXTENDED_WARRANTY };
  },
  valid(state) {
    return validateExtendedWarrantyCondition(state).valid;
  },
});

export { type ExtendedWarrantyState } from "@redotech/redo-model/return-flow/condition-validate";
